import { isFlaggedCancellationsUiVisible } from 'utils/flaggedCancellationUi';

/** Menu badge for flagged cancellations — count/tooltip aligned with prod; styling matches ui-kit nav chips. */

export const getFlaggedCancelCountFromState = (state) => {
  const report = state.getIn(['report', 'flaggedCancelCountReport']);
  if (!report) return 0;
  const js = typeof report.toJS === 'function' ? report.toJS() : report;
  const raw = js?.data?.count;
  const count = Number(raw);
  return Number.isFinite(count) && count > 0 ? count : 0;
};

export const formatFlaggedCancelBadgeLabel = (count) => (count > 50 ? '50+' : String(count));

export const getFlaggedCancelMenuTooltip = (count) =>
  `${count} policies/leases have been flagged for potential claim or cancellation. ` +
  'Please review the "Flagged Cancellations" tab to resolve. ' +
  'Please note that all claims and cancellations are not automatically processed without acknowledgement, ' +
  'and must be manually submitted via the portal.';

export const shouldShowFlaggedCancelMenuBadge = (menuItem, count) =>
  Boolean(isFlaggedCancellationsUiVisible() && menuItem?.showCancellationIcon && count > 0);
